<template>
  <div class="doc-refund" @click="selectNone">
    <div class="item">
      <div class="label">
        退款原因
      </div>
      <div class="value">
        <el-select v-model="value" placeholder="请选择" ref="select" :popper-append-to-body="false">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="item">
      <div class="label">
        其他原因
      </div>
      <div class="value">
        <el-input
          type="textarea"
          :rows="8"
          resize="none"
          placeholder="请输入其他原因..."
          v-model="textarea">
        </el-input>
      </div>
    </div>
    <div class="rule">
      <div class="title">退款须知</div>
      <p>1.如您未享受到任何陪驾服务，可全额退款；</p>
      <p>2.如您已使用过陪驾服务，可将剩余的服务时间对应的金额退回，已服务的部分无法退款；</p>
      <p>3.请根据实际情况填写退款原因，也可以提出意见或建议，我们会尽快改进服务质量；</p>
      <p>4.退款审核将在1-3个工作日完成，请耐心等待；</p>
      <p>5.如有疑问请咨询平台客服。</p>
    </div>
    <div class="btn-submit" @click="submit">提交</div>
    <ctl-dialog v-model="messageDialog" :loading="loading"/>
  </div>
</template>

<script>
import { Select, Option, Input } from 'element-ui'
import { Toast } from 'vant'
import dialog from '@/components/dialog/index'
export default {
    name: 'refund',
    methods: {
        selectNone () {
            this.$refs.select.blur()
        },
        getList () {
            this.$api.getRefundReasonPeijia().then(res => {
                if (res) {
                    res.result.forEach(v => {
                        this.options.push({
                            label: v.refundReason,
                            value: v.id
                        })
                    })
                }
            })
        },
        submit () {
            let data = {
                orderId: this.$route.query.id,
                otherReason: this.textarea,
                reasonId: this.value
            }
            if (!data.reasonId) {
                Toast.fail('请选择退款原因')
                return
            }
            Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
            this.$api.refundApplyPeijia(data).then(res => {
                Toast.clear()
                if (res.status) {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '我知道了',
                        rightBtnMethod: () => {
                            this.$router.replace({ name: 'peijiaOrderDetail', query: { id: this.$route.query.id, headShow: '0' } })
                        },
                        title: '提示',
                        content: '您的退款申请已提交，请等待斑斑客服处理！'
                    }
                } else {
                    Toast.fail(res.message)
                }
            })
        }
    },
    created () {
        this.getList()
    },
    data () {
        return {
            options: [],
            value: '',
            textarea: '',
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            }
        }
    },
    components: {
        ctlDialog: dialog,
        [Select.name]: Select,
        [Input.name]: Input,
        [Toast.name]: Toast,
        [Option.name]: Option
    }
}
</script>

<style scoped lang="scss">
  .doc-refund{
    box-sizing: border-box;
    padding: 20px 15px;
    overflow: hidden;
  }

  .item{
    margin: 0 0 24px 0;
    .label{
      font: 400 14px PingFangSC-Regular, PingFang SC;
      color: #333333;
    }
    .value{
      margin: 13px 0 0 0;

      /deep/ {

        .is-focus .el-input__inner{
          border-color: #53CB85;
        }
        .el-select .el-input__inner:focus{
          border-color: #53CB85;
        }
        .el-textarea__inner:focus{
          border-color: #53CB85;
        }
      }

    }
    .el-select{
      width: 100%;
      /deep/ .selected{
        color: #53CB85;
      }
    }
  }

  .rule{
    .title{
      font: 400 14px PingFangSC-Regular, PingFang SC;
      color: #333333;
    }
    p{
      font: 400 12px/24px PingFangSC-Regular, PingFang SC;
      color: #666666;
    }
  }

  /deep/{
    input,

    textarea {
      -webkit-appearance: none; /* 方法2 */
    }
  }

  .btn-submit{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px auto 0;
    width: 345px;
    height: 43px;
    background: #53CB85;
    border-radius: 22px;
    font: 400 17px PingFangSC-Regular, PingFang SC;
    color: #FFFFFF;
  }

</style>
